import Vue from 'vue'
import Vuex from 'vuex'

const fb = require('./firebaseConfig.js')

Vue.use(Vuex)

fb.auth.onAuthStateChanged(user => {
  if (user) {
    store.commit('setCurrentUser', user)
    store.dispatch('init')

    fb.db.collection('remedialCourse').get().then(querySnapshot => {
      let customersArray = []
      querySnapshot.forEach(doc => {
        let customer = doc.data()
        customer.id = doc.id
        customersArray.push(customer)
        store.commit('fetchRemedialCourse', customersArray)
      })
    })

    fb.db.collection('onlineCourse').get().then(querySnapshot => {
      let customersArray = []
      querySnapshot.forEach(doc => {
        let customer = doc.data()
        customer.id = doc.id
        customersArray.push(customer)
        store.commit('fetchOnlineCourse', customersArray)
      })
    })
    fb.db.collection('centerClass').get().then(querySnapshot => {
      let customersArray = []
      querySnapshot.forEach(doc => {
        let customer = doc.data()
        customer.id = doc.id
        customersArray.push(customer)
        store.commit('fetchCenterClass', customersArray)
      })
    })

    fb.staffCollection.doc(user.uid).get().then(doc => {
      fb.reservationCollection.doc(doc.data().shopId).collection('shopReservations').get().then(querySnapshot => {
        let reservationsArray = []
        querySnapshot.forEach(doc => {
          let reservation = doc.data()
          reservation.id = doc.id
          reservation.dateTime = new Date(doc.date)
          reservationsArray.push(reservation)
          store.commit('fetchReservations', reservationsArray)
        })
      })

      fb.customerDetailsCollection.doc(doc.data().shopId).collection('customers').get().then(querySnapshot => {
        let customersArray = []
        querySnapshot.forEach(doc => {
          let customer = doc.data()
          customer.id = doc.id
          customersArray.push(customer)
          store.commit('fetchCustomers', customersArray)
        })
      })

      fb.quotationCollection.doc(doc.data().shopId).collection('quotations').get().then(querySnapshot => {
        let quotationsArray = []
        querySnapshot.forEach(doc => {
          let quotation = doc.data()
          quotation.id = doc.id
          quotationsArray.push(quotation)
          store.commit('fetchQuotations', quotationsArray)
        })
      })
    })
  }
})

const store = new Vuex.Store({
  state: {
    currentUser: null,
    CurrectStaffProfile: '',
    reservations: [],
    customers: [],
    remedialCourse: [],
    onlineCourse: [],
    centerClass: []
  },
  mutations: {
    setCurrentUser (state, val) {
      state.currentUser = val
    },
    setCurrectStaffProfile (state, val) {
      state.CurrectStaffProfile = val
    },
    fetchReservations (state, val) {
      if (val) {
        state.reservations = val
      } else {
        state.reservations = []
      }
    },
    fetchRemedialCourse (state, val) {
      if (val) {
        state.remedialCourse = val
      } else {
        state.remedialCourse = []
      }
    },
    fetchOnlineCourse (state, val) {
      if (val) {
        state.onlineCourse = val
      } else {
        state.onlineCourse = []
      }
    },
    fetchCenterClass (state, val) {
      if (val) {
        state.centerClass = val
      } else {
        state.centerClass = []
      }
    },
    fetchCustomers (state, val) {
      if (val) {
        state.customers = val
      } else {
        state.customers = []
      }
    },
    fetchQuotations (state, val) {
      if (val) {
        state.quotations = val
      } else {
        state.quotations = []
      }
    }
  },
  actions: {
    init ({ commit, state }) {
      fb.userCollection.doc(state.currentUser.uid).get().then(res => {
        commit('setCurrectStaffProfile', res.data())
      }).catch(error => {
        console.log(error)
      })
    },
    clearData ({ commit }) {
      commit('setCurrentUser', null)
      commit('setCurrectStaffProfile', null)
    }
  }
})

export default store
